<template>
  <v-card class="mx-auto text-center" color="rgba(40,40,40,1)" dark>
    <v-card-text>
      <v-sheet color="rgba(50, 50, 50, .9)">
        <template>
          <div>
            <apexchart type="line" :options="options" :series="series"></apexchart>
          </div>
        </template>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="text-sm-body-2 text-md-h4 text-lg-h4 font-weight-thin">Sales Last 24h</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: function() {
    return {
      options: {
        chart: {
          id: "vuechart-example",
          background: "#111",
          toolbar: {
            show: false
          },
          zoom: false
        },
        tooltip: {
          enabled: false
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#a0c832",
            shadeTo: "dark",
            shadeIntensity: 1
          }
        }
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91]
        }
      ]
    };
  }
};
</script>